export default function removeAllErrorMsg() {
    let divs:any = document.querySelectorAll(".invalid-feedback")
    for (let ele of divs) {
        ele.style.display = "none"
    }
}